import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class JpkVatCodeShouldBeSelectedOnItemWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.sale.validation.document-jpk-vat-code-should-be-selected-on-item-warning');
    }
}
